import { Card, CardBody } from 'components/common/Card';
import CompanyTable, {
    CompanyTablePagination,
    CompanyTableSortField
} from 'components/CommonGroupAndCategoryStuff/CompanyTable';
import * as React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import {
    AggregationKeyFigureResponse,
    KeyFigureData,
    PageResponse,
    BasicKeyFigureInfo
} from 'components/context/types';
import {
    apiGetGroupKeyFigureAggregations,
    apiGetLatestGroupKeyFigures
} from 'api/groups';
import { prepareAggregationsToKeyFigureData } from 'utils/keyfigures';
import { CompanyKeyFigureGraphs } from 'components/common/KeyFigureGraph/CompanyKeyFigureGraphs';
import t from 'utils/translations';

export interface GroupContentProps {
    groupId: string;
    groupName: string;
    reload: boolean;
}

export default function GroupTabContent({
    groupId,
    groupName,
    reload
}: GroupContentProps) {
    const [graphData, setGraphData] = useState<KeyFigureData>({
        seriesName: '',
        keyFigures: []
    });

    const [tableData, setTableData] = useState<BasicKeyFigureInfo[]>(
        [] as BasicKeyFigureInfo[]
    );

    const [isLoading, setIsLoading] = useState(true);
    const [isGraphLoading, setIsGraphLoading] = useState(true);

    const [companyTableTotal, setCompanyTableTotal] = useState(0);
    const [companyTablePagination, setCompanyTablePagination] = useState({
        currentPage: 1,
        pageSize: 10,
        sortField: CompanyTableSortField.Name,
        sortOrder: 'ASC',
        total: 0
    } as CompanyTablePagination);

    useEffect(() => {
        fetchAndSetGroupKeyFigureAggregations();
    }, [reload]);

    useEffect(() => {
        fetchNewPage(
            companyTablePagination.currentPage,
            companyTablePagination.pageSize,
            companyTablePagination.sortField,
            companyTablePagination.sortOrder
        );
    }, [companyTablePagination, reload]);

    const fetchAndSetGroupKeyFigureAggregations = () => {
        apiGetGroupKeyFigureAggregations(groupId)
            .then(res => res.json())
            .then((data: AggregationKeyFigureResponse) => {
                setGraphData(
                    prepareAggregationsToKeyFigureData(data.content, groupName)
                );
            })
            .finally(() => setIsGraphLoading(false));
    };

    function fetchNewPage(
        page: number,
        size: number,
        field: CompanyTableSortField,
        order: 'ASC' | 'DESC'
    ) {
        setIsLoading(true);
        setTableData([]);
        apiGetLatestGroupKeyFigures(groupId, page, size, field, order)
            .then((data: PageResponse<BasicKeyFigureInfo>) => {
                setTableData(data.content);
                if (data.total) {
                    setCompanyTableTotal(data.total);
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    return (
        <>
            <CompanyKeyFigureGraphs
                canCompare={true}
                isAggregateData={true}
                showMonths={false}
                isLoading={isGraphLoading}
                keyFigureData={graphData}
                title={t('GROUPS_KEYFIGURES')}
            />
            <Card>
                <CardBody>
                    <CompanyTable
                        afterCompanyDeleteFunction={
                            fetchAndSetGroupKeyFigureAggregations
                        }
                        companyTablePagination={companyTablePagination}
                        fetchNewPage={fetchNewPage}
                        groupId={groupId}
                        isLoading={isLoading}
                        setCompanyTablePagination={setCompanyTablePagination}
                        tableData={tableData}
                        total={companyTableTotal}
                    />
                </CardBody>
            </Card>
        </>
    );
}
